import React from 'react';
import { useFormikContext } from 'formik';
import { FormGroup } from '../../form';
import { InputPassword } from '../../formikBindings';

const AdminLoginForm: React.FC = () => {
  const { isSubmitting } = useFormikContext();

  return (
    <FormGroup name="password" label="Password">
      <InputPassword name="password" disabled={isSubmitting} autoFocus />
    </FormGroup>
  );
};

export default AdminLoginForm;
